module.exports = __webpack_public_path__ + "dist/fonts/roboto/Roboto-Bold-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./dist/fonts/roboto/Roboto-Bold-webfont.woff
// module id = 1616
// module chunks = 0